let id = 0
/**
 * Generates incremental unique id.
 * @remark Should be used client side only.
 * @category Utils
 */
export const getIdClient = (prefix = 'id') => `${prefix}-${++id}`
